import getAuditTrailSummary from '@hooks/auditTrail/getAuditTrailSummary';

const useGetAuditTrailSummary = () => {
    return getAuditTrailSummary();
};

export default useGetAuditTrailSummary;
